import { getCurrentCountry, getCurrentCulture } from '@vp/culture-resolution';
import { isDevelopmentMode } from 'src/utils/tenantUtil';

const queryParams = new URLSearchParams(
  isDevelopmentMode() && typeof window !== 'undefined' ? window.location.search : ''
);

export const currentCountry = queryParams.get('country') || getCurrentCountry();
export const currentCulture = queryParams.get('culture') || getCurrentCulture();
export const currentLanguage = currentCulture.split('-')[0];
